import { render } from "./sso.vue?vue&type=template&id=5ed34cf8"
import script from "./sso.vue?vue&type=script&lang=js"
export * from "./sso.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Afwct\\emis2.0\\emis-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__